<template>
  <el-dialog
    title="批量新增人员成本"
    :visible.sync="dialogVisible"
    width="920px"
    append-to-body
    :close-on-click-modal="false"
    @open="onOpen"
  >
    <div class="batch-tip">每行填写一条成本：岗位、人员、成本类型、金额。可添加多行后一次性保存。</div>
    <div class="table-toolbar">
      <el-button type="primary" plain icon="el-icon-plus" size="small" @click="addRow">添加一行</el-button>
      <span v-if="rows.length" class="row-count">共 {{ rows.length }} 行</span>
    </div>
    <el-table :data="rows" border size="small" max-height="360" class="batch-table">
      <el-table-column type="index" label="#" width="44" align="center" />
      <el-table-column label="岗位" min-width="130">
        <template slot-scope="scope">
          <el-select
            v-model="scope.row.stationName"
            size="mini"
            placeholder="岗位"
            style="width: 100%"
          >
            <el-option v-for="s in stationOptions" :key="s.value" :label="s.label" :value="s.value" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="人员" min-width="180">
        <template slot-scope="scope">
          <cargo-advance-select
            :key="'user-' + scope.row._rowKey"
            style="width: 100%"
            filterable
            clearable
            :select-type="selectTypeNames.basic_data_User"
            :default-value="scope.row.userId || null"
            :callback-params="{ key: 'userId', rowIndex: scope.$index }"
            @parentCallBack="onUserSelected"
          />
        </template>
      </el-table-column>
      <el-table-column label="成本类型" min-width="110">
        <template slot-scope="scope">
          <el-select v-model="scope.row.costType" size="mini" placeholder="类型" style="width: 100%">
            <el-option v-for="t in costTypeOptions" :key="t.value" :label="t.label" :value="t.value" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column label="金额" width="140">
        <template slot-scope="scope">
          <el-input-number
            v-model="scope.row.amount"
            size="mini"
            :min="0"
            :precision="2"
            :step="100"
            :controls="false"
            placeholder="金额"
            style="width: 100%"
          />
        </template>
      </el-table-column>
      <el-table-column label="备注" min-width="120">
        <template slot-scope="scope">
          <el-input v-model="scope.row.remark" size="mini" placeholder="选填" maxlength="500" />
        </template>
      </el-table-column>
      <el-table-column label="按月累加" width="78" align="center">
        <template slot-scope="scope">
          <el-checkbox v-model="scope.row.autoMonthlyChecked" />
        </template>
      </el-table-column>
      <el-table-column label="操作" width="64" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            style="color:#F56C6C"
            :disabled="rows.length <= 1"
            @click="removeRow(scope.$index)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer">
      <el-button :disabled="submitting" @click="dialogVisible = false">取消</el-button>
      <el-button type="primary" :loading="submitting" @click="handleSubmit">保存</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { savePersonCostItem } from '@/api/provision/provisionRule'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as ProvisionConstants from '@/class/cargo/model/parameters/ProvisionConstants'

let rowSeed = 0

export default {
  name: 'PersonCostBatchDialog',
  components: { cargoAdvanceSelect },
  props: {
    visible: { type: Boolean, default: false }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      stationOptions: ProvisionConstants.CONFIGURABLE_STATIONS,
      costTypeOptions: ProvisionConstants.PERSON_COST_TYPE_OPTIONS,
      rows: [],
      submitting: false
    }
  },
  computed: {
    dialogVisible: {
      get() { return this.visible },
      set(val) { this.$emit('update:visible', val) }
    }
  },
  methods: {
    createEmptyRow() {
      rowSeed += 1
      return {
        _rowKey: rowSeed,
        stationName: '',
        userId: '',
        userName: '',
        costType: 'base_salary',
        amount: undefined,
        remark: '',
        autoMonthlyChecked: false
      }
    },
    onOpen() {
      this.rows = [this.createEmptyRow(), this.createEmptyRow(), this.createEmptyRow()]
      this.submitting = false
    },
    addRow() {
      this.rows.push(this.createEmptyRow())
    },
    removeRow(index) {
      if (this.rows.length <= 1) return
      this.rows.splice(index, 1)
    },
    onUserSelected(data) {
      if (!data) return
      const rowIndex = data.rowIndex
      if (rowIndex == null || !this.rows[rowIndex]) return
      const userId = data.key === 'userId' ? data.value : (data.value || data.userId)
      if (!userId) return
      const row = this.rows[rowIndex]
      row.userId = String(userId)
      row.userName = data.chineseName || data.userName || data.englishName || data.label || String(userId)
    },
    isRowFilled(row) {
      return !!(row.stationName || row.userId || row.costType !== 'base_salary' || row.amount != null || row.remark)
    },
    validateRows(validRows) {
      for (let i = 0; i < this.rows.length; i++) {
        const row = this.rows[i]
        if (!this.isRowFilled(row)) continue
        const lineNo = i + 1
        if (!row.stationName) {
          return `第 ${lineNo} 行：请选择岗位`
        }
        if (!row.userId) {
          return `第 ${lineNo} 行：请选择人员`
        }
        if (!row.costType) {
          return `第 ${lineNo} 行：请选择成本类型`
        }
        if (row.amount == null || Number(row.amount) <= 0) {
          return `第 ${lineNo} 行：请输入大于 0 的金额`
        }
        validRows.push(row)
      }
      if (!validRows.length) {
        return '请至少填写一行完整数据'
      }
      return ''
    },
    async handleSubmit() {
      const validRows = []
      const errMsg = this.validateRows(validRows)
      if (errMsg) {
        this.$message.warning(errMsg)
        return
      }
      this.submitting = true
      try {
        for (const row of validRows) {
          const res = await savePersonCostItem({
            stationName: row.stationName,
            userId: row.userId,
            userName: row.userName,
            costType: row.costType,
            amount: row.amount,
            remark: row.remark,
            autoMonthly: row.autoMonthlyChecked ? '1' : '0'
          })
          if (!res.ok) {
            this.$message.error(res.message || '保存失败')
            return
          }
        }
        this.$message.success(`已成功保存 ${validRows.length} 条成本`)
        this.dialogVisible = false
        this.$emit('success')
      } finally {
        this.submitting = false
      }
    }
  }
}
</script>

<style scoped>
.batch-tip {
  color: #909399;
  font-size: 12px;
  margin-bottom: 12px;
  line-height: 1.5;
}
.table-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 10px;
}
.row-count {
  color: #606266;
  font-size: 12px;
}
.batch-table >>> .el-input-number .el-input__inner {
  text-align: left;
}
</style>
